<list-view *ngIf="listeUsers" [liste]="listeUsers"></list-view>
<floating-button [listeActions]="listeActions" *ngIf="listeActions"></floating-button>